export const getClient = (clientType: string) => {
    const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    const isPoker = clientType === 'poker';

    if (isIos && isPoker) {
        return 'ios';
    }

    if (isAndroid && isPoker) {
        return 'android';
    }

    return 'web';
};

